import { listBlogPosts, refreshBlogPostAutor } from './blogApi';

// Intervalo entre cada post atualizado — de propósito NÃO é tudo de uma vez:
// se o autor tem vários artigos, uma rajada de gravações simultâneas no
// Firestore é desnecessária pra algo que não é urgente (é só a assinatura
// de posts já publicados acompanhando uma troca de foto/nome).
const SYNC_DELAY_MS = 4000;

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Disparado depois que "Minha conta" salva nome/foto novos (ver
 * AccountDialog.tsx) — reaplica a mesma denormalização que já roda na
 * criação de um post (ver api/blog/post.ts, refreshAutor) em cada artigo já
 * existente dessa pessoa, um de cada vez, com um intervalo entre eles. Best
 * effort: roda em segundo plano, sem travar o diálogo nem re-lançar erro —
 * se a aba fechar no meio, os posts que faltaram só não atualizam agora
 * (nada quebra, e um próximo salvamento de perfil tenta de novo em todos).
 */
export async function syncAuthorAcrossPosts(uid: string, idToken: string): Promise<void> {
  let posts;
  try {
    ({ posts } = await listBlogPosts(idToken));
  } catch {
    return;
  }

  const ownPosts = posts.filter((post) => post.autorId === uid);
  for (const post of ownPosts) {
    try {
      await refreshBlogPostAutor(post.id, idToken);
    } catch {
      // Um post falhar não deve travar a atualização dos outros.
    }
    await delay(SYNC_DELAY_MS);
  }
}
